@if (!isLoadingNav()) {
  <grafologia-barra-navegacion 
    [items]="navItems()" 
    [comportamiento]="comportamiento()"
    [seccionesObservadas]="seccionesObservadas()"
    [PaginaPrincipal]="paginaPrincipal()">
  </grafologia-barra-navegacion>
}

<main>
  <router-outlet></router-outlet>
</main>